import {
  Req_GetRoleList
} from '@/request/role'

export default {
  state: {
    roleList: []
  },
  mutations: {
    updateRoleList(state,payload) {
      state.roleList = payload
    }
  },
  actions: {
    getRoleList(store){
      Req_GetRoleList().then(res => {
        store.commit('updateRoleList',res)
      }).catch(err => this.$catchErr(err))
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/role.js